// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_RegrasDeGruposResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /usuarios/regras_de_grupos (skill `app-groups`).
 *
 * O que a tela de usuários precisa saber sobre os grupos SEM conhecer nome nenhum: quais são de
 * app (conta só com eles não recebe franquia) e quais atributos cada grupo destrava.
 */
import type { Usuarios_GrupoApresentadoRow } from './Usuarios_GrupoApresentadoRow'
import type { Usuarios_RegraDeAtributoRow } from './Usuarios_RegraDeAtributoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Usuarios_RegrasDeGruposResponseDados {
grupos_de_app: string[]
atributos: Usuarios_RegraDeAtributoRow[]
catalogo: Usuarios_GrupoApresentadoRow[]
}

export type Usuarios_RegrasDeGruposResponse = ApiResponse<Usuarios_RegrasDeGruposResponseDados>;

registerResponseContract('Usuarios_RegrasDeGruposResponse', {
  grupos_de_app: { type: 'array',   required: true },
  atributos: {
    type: 'array',
    required: true,
    items: {
      atributo:    { type: 'string',  required: true },
      grupo:       { type: 'string',  required: true },
      pode_editar: { type: 'boolean', required: false },
    },
  },
  catalogo: {
    type: 'array',
    required: true,
    items: {
      grupo:    { type: 'string',  required: true },
      tipo:     { type: 'string',  required: true },
      rotulo:   { type: 'string',  required: true },
      resumo:   { type: 'string',  required: true },
      pode:     { type: 'array',   required: false },
      nao_pode: { type: 'array',   required: false },
      sensivel: { type: 'boolean', required: false },
      ordem:    { type: 'number',  required: false },
      area:     { type: 'string',  required: false },
      secao:    { type: 'string',  required: false },
      app:      { type: 'string',  required: false },
    },
  },
})
